import React from 'react';
import Text from 'v3/components/Text';
import { Wrapper, ToggleList, NfToggleButton, EmptyLabel, ErrorLabel } from './styles';

export function AttachmentNFCheckboxes({
  attachmentIndex,
  nfOptions = [],
  files = [],
  setFiles = () => {},
  readOnly = false,
  showError = false,
  readOnlyNfDocuments = null,
}) {
  const effectiveNfOptions =
    readOnly && readOnlyNfDocuments
      ? readOnlyNfDocuments.map(d => ({
          id: d.nfsId,
          nfNumber: d.loadNf?.nfNumber || String(d.nfsId),
        }))
      : nfOptions;

  const selectedNfIds =
    readOnly && readOnlyNfDocuments
      ? readOnlyNfDocuments.map(d => d.nfsId)
      : files[attachmentIndex]?.selectedNfIds || [];

  function handleToggle(nfId) {
    if (readOnly) return;
    const current = files[attachmentIndex]?.selectedNfIds || [];
    const updated = current.includes(nfId)
      ? current.filter(id => id !== nfId)
      : [...current, nfId];
    setFiles(
      files.map((file, idx) =>
        idx === attachmentIndex ? { ...file, selectedNfIds: updated } : file
      )
    );
  }

  if (!Array.isArray(effectiveNfOptions) || effectiveNfOptions.length === 0) {
    if (readOnly) return null;
    return <EmptyLabel>Adicione notas fiscais à ocorrência primeiro</EmptyLabel>;
  }

  return (
    <Wrapper>
      <Text type="label" color="dark" weight={500}>
        {readOnly ? 'Notas fiscais vinculadas:' : 'Vincular às NF-es'}
      </Text>
      <ToggleList>
        {effectiveNfOptions.map(nf => {
          const isActive = selectedNfIds.includes(nf.id);
          return (
            <NfToggleButton
              key={nf.id}
              type="button"
              disabled={readOnly}
              active={isActive}
              onClick={() => handleToggle(nf.id)}
            >
              {nf.nfNumber}
            </NfToggleButton>
          );
        })}
      </ToggleList>
      {showError && selectedNfIds.length === 0 && (
        <ErrorLabel>Selecione pelo menos uma NF</ErrorLabel>
      )}
    </Wrapper>
  );
}
